import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@acme/tailwind-config/tailwind.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router";
import { NavBar } from "./components/EditorNavbar";
import { AuthLayout } from "./layouts/AuthLayout";
import { EditorLayout } from "./layouts/EditorLayout";
import { TuiLayout } from "./layouts/TuiLayout";
import EditorPage from "./pages/EditorPage";
import HomePage from "./pages/HomePage";
import { LoginPage } from "./pages/LoginPage";
import { TestPage } from "./pages/TestPage";
import { TerminalUI } from "./pages/TuiPage";

import { PostHogProvider } from "posthog-js/react";
import { TRPCContext } from "./context/TRPCContext";
import ExcalidrawPage from "./pages/ExcalidrawPage";
import JoinPage from "./pages/JoinPage";
import PickTemplatePage from "./pages/PickTemplatePage";
import Home from "./pages/AdminDashboard/Home";
import AdminDashboardSidebarLayout from "./layouts/DashboardSidebar";

const options = {
	api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST ?? "",
};

const queryClient = new QueryClient();

// biome-ignore lint/style/noNonNullAssertion: Needed for root
createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<PostHogProvider
			apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY ?? ""}
			options={options}
		>
			<QueryClientProvider client={queryClient}>
				<TRPCContext>
					<BrowserRouter>
						<Routes>
							<Route element={<TuiLayout />}>
								<Route path="/" element={<TerminalUI />} />
								<Route path="/template" element={<PickTemplatePage />} />
								<Route path="/join" element={<JoinPage />} />
								<Route path="/login" element={<LoginPage />} />
							</Route>

							<Route path="/test" element={<TestPage />} />
							<Route
								path="/editor/:projectId"
								element={<EditorLayout mode="editor" />}
							>
								<Route index element={<EditorPage />} />
								<Route path="excalidraw" element={<ExcalidrawPage />} />
								<Route path="notepad" element={<p>Notepad</p>} />
							</Route>

							<Route
								path="/share/:shareCode"
								element={<EditorLayout mode="share" />}
							>
								<Route index element={<EditorPage />} />
								<Route path="excalidraw" element={<ExcalidrawPage />} />
								<Route path="notepad" element={<p>Notepad</p>} />
							</Route>
							<Route
								path="/dashboard"
								element={<AdminDashboardSidebarLayout />}
							>
								<Route index element={<Home />} />
								<Route path="live-sessions" element={<p>Projects</p>} />
								<Route path="users" element={<p>Users</p>} />
								<Route path="templates" element={<p>Templates</p>} />
								<Route path="assignments" element={<p>Assignments</p>} />
							</Route>
						</Routes>
					</BrowserRouter>
				</TRPCContext>
			</QueryClientProvider>
		</PostHogProvider>
	</StrictMode>,
);

// https://run.zip/join?c=1a8f1f7e
